/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./serviceBuilders.vue?vue&type=template&id=b8fc4784"
import script from "./serviceBuilders.vue?vue&type=script&lang=js"
export * from "./serviceBuilders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports